module.exports = __webpack_public_path__ + "img/1.74ea2a44.jpg";